import axios from 'axios';
import { EnvironmentConfig } from '../services/constants.js';

export default {
    name: 'LoginService',
    data() {
        return {
            baseApiUrl: '',
            APIKey: ''
        }
    },
    created: function () {
        //URL and endpoint constants
        this.baseApiUrl = EnvironmentConfig._baseURL;
        this.APIKey = EnvironmentConfig._APIURL;
    },
    methods: {
        login(email, token) {
            const params = { "Email": email, "Token": token }
            const loginUrl = this.baseApiUrl + '/users/authenticate';
            return axios({
                method: 'post',
                url: loginUrl,
                headers: {
                    'APIKey': this.APIKey
                },
                data: params
            })
                .then(function (response) {
                    if (response) {
                        return response;
                    }
                });
        },
        getJWTToken(email) {
            const params = { "UserName": email }
            const loginUrl = this.baseApiUrl + '/users/GetToken';
            return axios({
                method: 'post',
                url: loginUrl,
                headers: {
                    'APIKey': this.APIKey
                },
                data: params
            })
                .then(function (response) {
                    if (response) {
                        return response;
                    }
                });
        },
        logout() {
            // remove user from local storage to log user out
            localStorage.removeItem('userName');
            localStorage.removeItem('token');
            localStorage.clear();
        },
        SaveUserDetails(email, firstname, lastname) {
            const saveUserDetails = this.baseApiUrl + '/users/SaveUserDetails';
            const params = {
                "Email": email,
                "FirstName": firstname,
                "LastName": lastname,
                "UserName": localStorage.getItem('userName')
            };
            return axios({
                method: 'post',
                url: saveUserDetails,
                headers: {
                    'APIKey': this.APIKey
                },
                data: params
            }).then(response => {
                if (response)
                    return response
            }).catch(error => {
                return error;
            })
        },
        CheckRegisterUser(email) {
            const saveUserDetails = this.baseApiUrl + '/users/CheckRegisterUser';
            const params = {
                "Email": email
            };
            return axios({
                method: 'post',
                url: saveUserDetails,
                headers: {
                    'APIKey': this.APIKey
                },
                data: params
            }).then(response => {
                if (response)
                    return response
            }).catch(error => {
                return error;
            })
        }
    }
}

